import React from 'react'
import { PageHeader, PageContent } from 'SRC/ui'
import { getProfileLoading } from '../../../selectors'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Preloader } from 'SRC/ui/Preloader'

export class Comments extends React.Component {
  render () {
    return [
      <PageHeader key='header'>Javna pitanja</PageHeader>,
      <PageContent key='content'>
        <div className='poruke-pretraga'>
          <div className='custom-select'>
            <a href='#'><i className='ico-javna-pitanja-sve ico' />Sva pitanja</a>
            <ul>
              <li><a href='#'><i className='ico-javna-pitanja-sve ico' />Sva pitanja</a></li>
              <li><a href='#'><i className='ico-javna-pitanja-neodgovoreno ico' />Neodgovoreno</a></li>
              <li><a href='#'><i className='ico-javna-pitanja-odgovoreno ico' />Odgovoreno</a></li>
            </ul>
          </div>
          <div className='input-pretraga'>
            <input type='text' placeholder='Pretraži javna pitanja...' />
            <button><i className='ico-pretraga-text-search-lupa ico' /></button>
          </div>
        </div>
        <div className='poruke-akcije poruke-akcije-javna-pitanja'>
          <div className='poruke-akcije-left'>
            <p>Oglas</p>
            <p>Korisnik</p>
          </div>
          <div className='poruke-akcije-right'>
            <p>Status</p>
            <p>Vrijeme</p>
          </div>
        </div>
        <div className='poruke-content'>
          <div className='javna-pitanja-item neodgovoreno-pitanje'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Mercedes Benz - C 220 CDI AMG</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(nije odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>prije 1h</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item neodgovoreno-pitanje'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Mercedes Benz - C 220 CDI AMG</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(nije odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>juče u 22:32h</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Motori: Kawasaki - Zx6r</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(nije odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>prije 7 dana</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='poruke-item-content-heading'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
          <div className='javna-pitanja-item'>
            <a href='#'>
              <div className='javna-pitanja-item-img'>
                <img src='https://placehold.it/75x56' alt='' />
              </div>
              <div className='javna-pitanja-item-content'>
                <div className='poruke-item-content-user-status'>
                  <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                </div>
                <div className='poruke-item-content-heading'>
                  <p>Automobili: Volkswagen - Touareg 3.0tdi</p>
                </div>
              </div>
              <div className='javna-pitanja-status'>
                <p>(odgovoreno)</p>
              </div>
              <div className='javna-pitanja-vreme'>
                <p>25.10.2016</p>
              </div>
            </a>
          </div>
        </div>
        <div className='poruke-pagination'>
          <ul>
            <li><a href='#'>prethodna</a></li>
            <li className='active'><a href='#'>1</a></li>
            <li><a href='#'>2</a></li>
            <li><a href='#'>3</a></li>
            <li><a href='#'>4</a></li>
            <li><a href='#'>5</a></li>
            <li><a href='#'>6</a></li>
            <li><a href='#'>...</a></li>
            <li><a href='#'>99</a></li>
            <li><a href='#'>100</a></li>
            <li><a href='#'>sledeća</a></li>
          </ul>
        </div>
        {this.props.isLoading ? <Preloader /> : null}
      </PageContent>
    ]
  }
}

const mapStateToProps = state => ({
  isLoading: getProfileLoading(state)
})

Comments.propTypes = {
  isLoading: PropTypes.bool.isRequired
}

Comments.defaultProps = {
  isLoading: false
}

export default connect(mapStateToProps)(Comments)
